import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
  ViewModes,
} from '@spartacus/storefront';
import { GlobalMessageService } from '@spartacus/core';
import { ProductSearchPage } from '@spartacus/core';
import { BehaviorSubject, Observable, Subscription, take } from 'rxjs';

@Component({
    selector: 'app-gonvarri-product-list',
    templateUrl: './gonvarri-product-list.component.html',
    styleUrl: './gonvarri-product-list.component.scss',
    standalone: false
})
export class GonvarriProductListComponent extends ProductListComponent implements OnInit, OnDestroy {

  private customSubscription = new Subscription();

  override model$: Observable<ProductSearchPage>;
  override viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  override ViewModes = ViewModes;
  override isInfiniteScroll: boolean = false;

  constructor(
    private customPageLayoutService: PageLayoutService,
    private customProductListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig
  ) {
    super(customPageLayoutService, customProductListComponentService, globalMessageService, scrollConfig);

    this.model$ = this.customProductListComponentService.model$;
  }

  override ngOnInit(): void {
    this.isInfiniteScroll = Boolean(this.scrollConfig.view?.infiniteScroll?.active);
    this.customProductListComponentService.getPageItems(0);
    this.customSubscription.add(
      this.customPageLayoutService.templateName$
        .pipe(take(1))
        .subscribe(() => {
          this.viewMode$.next(ViewModes.Grid);
        })
    );
  }

  override ngOnDestroy(): void {
    this.customSubscription.unsubscribe();
  }
}
